var map = {
	"./3gp.png": 440,
	"./ai.png": 441,
	"./avi.png": 442,
	"./bmp.png": 443,
	"./doc.png": 444,
	"./docx.png": 445,
	"./dwg.png": 446,
	"./dxf.png": 447,
	"./eps.png": 448,
	"./flv.png": 449,
	"./folder.png": 60,
	"./gif.png": 450,
	"./jpeg.png": 451,
	"./jpg.png": 452,
	"./mov.png": 453,
	"./mpeg2.png": 454,
	"./mpeg4.png": 455,
	"./no.png": 42,
	"./pdf.png": 456,
	"./png.png": 457,
	"./ppt.png": 458,
	"./pptx.png": 459,
	"./psd.png": 460,
	"./rm.png": 461,
	"./rmvb.png": 462,
	"./svg.png": 463,
	"./txt.png": 464,
	"./webp.png": 465,
	"./wmv.png": 466,
	"./word.png": 467,
	"./xls.png": 468,
	"./xlsx.png": 469,
	"./zip.png": 470
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 79;


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/file ^\.\/.*\.png$
// module id = 79
// module chunks = 1 2